<template>
<WSServer />
</template>

<script>
import WSServer from '../components/WSServerComponent';

export default {
    components: {
        WSServer,
    },
};
</script>
